<template>
  <TouchLayout>
    <div class='main'>
        <div class='box-title'>
            <div class='title'>
                이용권 목록
            </div>
            <button class='box-back' @click='back'>
                <div class='arrow-left'>
                </div>
                <div class='back-txt'>
                    이전 화면
                </div>
            </button>
        </div>
        <div class='box-tab'>
            <button v-for="(tab, index) in tabs" :key="index"
                class='tab'
                :class="{'active-tab': currentTab === index}"
                @click="selectTab(index)">
                {{ tab }}
            </button>
        </div>
        <div class='box-list'>
            <div v-if='reserveList.length > 0'>
                <div v-for='(r,index) in reserveList' :key='index' class='card'>
                    <div class='left'
                        :class="{
                            private: r.cp_ticket_type_cd == 'P',
                            ot: r.cp_ticket_type_cd == 'O',
                            duet: r.cp_ticket_type_cd == 'D',
                            coupon: r.cp_ticket_type_cd == 'C',
                            group: r.cp_ticket_type_cd == 'G',
                            member: r.cp_ticket_type_cd == 'T',
                            wear: r.cp_ticket_type_cd == 'S',
                        }"
                    >
                    </div>
                    <div class='center'>
                        <div class='box-info'>
                            <div class='info-product-name'>
                                {{ convertTicket(r.cp_ticket_type_cd) }} {{ r.ccp_prod_nm }}
                            </div>
                            <div class='box-info-date'>
                                <div class='info-date'>
                                    {{ r.cc_exp_start_dt | timestampFilter4 }} ~ {{ r.cc_exp_end_dt | timestampFilter4 }}
                                </div>
                                <div v-if='currentTab == 0' class='info-expired'>
                                    {{ r.cc_diff_day }}일 남음
                                </div>
                                <div v-if='currentTab == 1' class='info-expired not'>
                                    미사용
                                </div>
                                <div v-if='currentTab == 2' class='info-expired late'>
                                    {{ r.cc_diff_day }}일 경과 
                                </div>
                            </div>
                        </div>
                        <div v-if="r.ccp_less_cnt_type_cd === 'T' || r.ccp_less_cnt_type_cd === 'W'" class='lesson-count'>
                            <span v-if="r.ccp_less_cnt_type_cd === 'T'">
                                잔여횟수 
                                <span v-if='!r.resv_total_cnt' class='blue'> {{ r.cc_less_cnt }} </span>
                                <span v-else class='blue'> {{ r.cc_less_cnt - r.resv_total_cnt }} </span>
                                / {{ r.cc_less_cnt }} 회 
                            </span>
                            <span v-else-if="r.ccp_less_cnt_type_cd === 'W'">
                                잔여횟수 주 {{ r.cc_less_cnt }} 회 
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class='no-ticket-box'>
                <div class='no-ticket-icon'>
                </div>
                <div class='no-ticket-txt'>
                    이용권이 없습니다
                </div>
            </div>
        </div>
    </div>
  </TouchLayout>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import TouchLayout from '@/layouts/TouchLayout';

export default {
name: 'touchReservationTicket',
components: {
    TouchLayout,
},
computed: {
    cId() {
        const { getters } = this.$store;
        return getters['auth/cId'];
    },
},
data() {
    return {
        nowDate: moment().format('YYYY.MM.DD'),
        today: moment().format('YYYY-MM-DD'),
        nowTime: moment().format('hh:mm:ss'),
        centerCustomerId: this.$route.query.custId,
        centerCustomerName: this.$route.query.name,
        reserveList: '',
        reserveListOrg: '',
        customerInfo: {}, // 회원 정보
        centerId: this.$route.query.centerId,
        currentTab: 0,  // 현재 선택된 탭 인덱스
        tabs: ['사용중', '미사용', '만료']  // 탭 이름 배열
    };
    },
    mounted() {
        setInterval(
            () => {
                this.nowTime = moment().format('hh:mm:ss');
            }
            , 1000,
        );
        Promise.allSettled([
            this.fetchCustomerDetail(), // 회원정보 가져오기
            this.onSearchList()
        ]);
    },
    methods: {
        back() {
            this.$router.push({
                path: '/touch/reservation/main',
                query: {
                    centerId: this.centerId,
                    custId: this.centerCustomerId,
                    name: this.centerCustomerName,
                },
            });
        },
        async onSearchList() {
            try {
                let { data } = await this.getSearchLsit();
                console.log(data);

                // 경과일 절대값으로 변경
                for(let reserve of data) {
                    reserve.cc_diff_day = Math.abs(reserve.cc_diff_day);
                }

                // 만료일 가까운 순으로 정렬
                data.sort((a, b) => {
                     // 오늘 날짜
                    const today = moment();

                    // 날짜 문자열을 Date 객체로 변환
                    const dateA = moment(a.cc_exp_end_dt);
                    const dateB = moment(b.cc_exp_end_dt);

                    // 오늘과 각 날짜의 차이 계산
                    const diffA = Math.abs(today.diff(dateA, 'days'));
                    const diffB = Math.abs(today.diff(dateB, 'days'));

                    // 차이를 비교하여 정렬
                    return diffA - diffB;
                });

                // 원본 데이터
                this.reserveListOrg = data;

                // 사용중
                this.reserveList = this.reserveListOrg.filter( reserve => moment().format('YYYY-MM-DD') >= moment(reserve.cc_exp_start_dt).format('YYYY-MM-DD') && moment().format('YYYY-MM-DD') <= moment(reserve.cc_exp_end_dt).format('YYYY-MM-DD') )
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getSearchLsit() {
            return api.get(`/admin/api/center/${this.cId}/lesson/list/all?productType=T&centerCustomerId=${this.centerCustomerId}`);
        },
        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                for(let i in this.customerInfo.centerLockers) {
                    if(this.customerInfo.centerLockers[i].lockerStatus != 'F') {
                        this.customerInfo.centerLocker = this.customerInfo.centerLockers[i];
                        const rentEndedDay = moment(this.customerInfo.centerLocker.rentEndedAt);
                        const currentDate = moment();
                        this.customerInfo.centerLocker.rentRemainDays = rentEndedDay.diff(currentDate,"days")
                        // return (remainDays >= 0) ? `-${remainDays}` : String(remainDays).replace('-', '+');

                        break;
                    }
                }
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}`);
        },
        selectTab(selectedIndex) {
            this.currentTab = selectedIndex;

            // 사용중, 미사용, 만기 분기
            if(this.currentTab == 0) {
                this.reserveList = this.reserveListOrg.filter( reserve => moment().format('YYYY-MM-DD') >= moment(reserve.cc_exp_start_dt).format('YYYY-MM-DD') && moment().format('YYYY-MM-DD') <= moment(reserve.cc_exp_end_dt).format('YYYY-MM-DD') )
            }else if(this.currentTab == 1) {
                this.reserveList = this.reserveListOrg.filter( reserve => moment().format('YYYY-MM-DD') < moment(reserve.cc_exp_start_dt).format('YYYY-MM-DD') )
            }else if(this.currentTab == 2) {
                this.reserveList = this.reserveListOrg.filter( reserve => moment().format('YYYY-MM-DD') >= moment(reserve.cc_exp_end_dt).format('YYYY-MM-DD') )
            }
        },
        convertTicket(val) {
            switch (val) {
                case 'P':
                    return '[개인]';
                    break;
                case 'O':
                    return '[OT]';
                    break;
                case 'D':
                    return '[듀엣]';
                    break;
                case 'G':
                    return '[그룹]';
                    break;
                case 'T':
                    return '[회원권]';
                    break;
            }
        },
    },
};
</script>

<style lang='scss' scoped>

    .box-title {
        width: 100%;
        max-width: 1200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;

        .title {
            font-family: Pretendard;
            font-size: 28px;
            font-weight: 700;
            line-height: 40px;
            letter-spacing: -0.6000000238418579px;
            text-align: left;
            color: #333333;
        }

        .box-back {
            display: flex;
            align-items: center;
            background-color: #F2F7FE;

            .arrow-left {
                width: 32px;
                height: 32px;
                background: url(/img/icons/arrow_left.png) no-repeat;
                background-position: center !important;
            }

            .back-txt {
                font-family: Pretendard;
                font-size: 28px;
                font-weight: 700;
                line-height: 40px;
                letter-spacing: -0.6000000238418579px;
                text-align: left;
                color: #808080;
            }
        }
    }

    .box-tab {
        width: 100%;
        max-width: 1200px;
        margin-top: 24px;
        display: flex;

        .tab {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 94px;
            height: 48px;
            font-family: Pretendard;
            font-size: 24px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: -0.6000000238418579px;
            color: #555555;
            background-color: #F2F7FE;
        }

        .active-tab {
            font-weight: 700;
            color: #0078F4;
            border-bottom: 4px solid #0078F4;
        }
    }

    .box-list {
        width: 100%;
        max-width: 1200px;
        height: calc(100% - 40px - 48px);
        overflow: auto;
    }

    .card {
        display: flex;
        align-items: stretch;
        margin-top: 16px;

        .left {
            width: 24px;
            border-radius: 16px 0px 0px 16px;

            &.private {
                background-color: var(--ticket-private-color);
            }

            &.ot {
                background-color: var(--ticket-ot-color);
            }

            &.duet {
                background-color: var(--ticket-duet-color);
            }

            &.coupon {
                background-color: var(--ticket-coupon-color);
            }

            &.group {
                background-color: var(--ticket-group-color);
            }

            &.member {
                background-color: var(--ticket-member-color);
            }

            &.wear {
                background-color: var(--ticket-wear-color);
            }
        }

        .center {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: calc(100% - 24px);
            padding: 24px 32px;
            background-color: white;

            // 태블릿 (가로 해상도가 769px 보다 작은 화면에 적용)
            @media (max-width: 768px) {
                flex-direction: column;
                align-items: baseline;
            }

            .box-info {
                display: flex;
                flex-direction: column;

                .info-product-name {
                    font-family: Pretendard;
                    font-size: 32px;
                    font-weight: 700;
                    line-height: 32px;
                    letter-spacing: -0.6000000238418579px;
                    color: #535353;
                }

                .box-info-date {
                    display: flex;
                    align-items: center;
                    margin-top: 8px;

                    .info-date {
                        font-family: Pretendard;
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 24px;
                        letter-spacing: -0.6000000238418579px;
                        color: #535353;
                    }

                    .info-expired {
                        font-family: Noto Sans CJK KR;
                        font-size: 20px;
                        font-weight: 500;
                        line-height: 24px;
                        letter-spacing: -0.6000000238418579px;
                        color: #3EC729;
                        padding: 4px 12px 4px 12px;
                        border-radius: 16px;
                        border: 1px solid #3EC729;
                        margin-left: 8px;

                        &.not {
                            color: #CCCCCC; 
                            border-color: #CCCCCC;
                        } 

                        &.late {
                            color: #F64444; 
                            border-color: #F64444;
                        } 
                    }
                }
            }

            .lesson-count {
                font-family: Pretendard;
                font-size: 24px;
                font-weight: 500;
                line-height: 24px;
                letter-spacing: -0.6000000238418579px;
                color: #535353;

                // 태블릿 (가로 해상도가 769px 보다 작은 화면에 적용)
                @media (max-width: 768px) {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    margin-top: 16px;
                }

                .blue {
                    color: #0078F4;
                }
            }
        }
    }

    .no-ticket-box {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .no-ticket-icon {
            width: 160px;
            height: 160px;
            background: url(/img/icons/touch_no_ticket.png) no-repeat;
            background-position: center !important;
        }

        .no-ticket-txt {
            margin-top: 32px;
            font-family: Noto Sans CJK KR;
            font-size: 24px;
            font-weight: 500;
            line-height: 28px;
            letter-spacing: -0.6000000238418579px;
            color: #93C8FF;
        }
    }


</style>
